var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoardViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.5C2.5 16.0523 2.94772 16.5 3.5 16.5H8.5V2.5H3.5C2.94772 2.5 2.5 2.94772 2.5 3.5V15.5Z",
    stroke: "#6F767E",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.5H20.5C21.0523 16.5 21.5 16.0523 21.5 15.5V3.5C21.5 2.94772 21.0523 2.5 20.5 2.5H15.5V16.5Z",
    stroke: "#6F767E",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 20.5C8.5 21.0523 8.94772 21.5 9.5 21.5H14.5C15.0523 21.5 15.5 21.0523 15.5 20.5V2.5H8.5V20.5Z",
    stroke: "#6F767E",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardViewIcon);
export default __webpack_public_path__ + "static/media/board_view_icon.70d910d615357df273fbdc16fea0fe94.svg";
export { ForwardRef as ReactComponent };